import localforage from "localforage";

export const inspectionsStore = localforage.createInstance({
  name: "uc-crash",
  storeName: "inspections",
});

export const photoStore = localforage.createInstance({
  name: "uc-crash",
  storeName: "photos",
});

export const metaStore = localforage.createInstance({
  name: "uc-crash",
  storeName: "meta",
});

export function newId() {
  if (crypto && crypto.randomUUID) return crypto.randomUUID();
  return "id-" + Date.now() + "-" + Math.random().toString(16).slice(2);
}

export function nowIso() {
  return new Date().toISOString();
}

export async function saveInspection(insp) {
  insp.updated_at = nowIso();
  await inspectionsStore.setItem(insp.client_id, insp);
  return insp;
}

export async function getInspection(clientId) {
  return await inspectionsStore.getItem(clientId);
}

export async function listInspections() {
  const items = [];
  await inspectionsStore.iterate((v) => {
    items.push(v);
  });
  items.sort((a, b) => (b.updated_at || "").localeCompare(a.updated_at || ""));
  return items;
}

export async function deleteInspectionLocal(clientId) {
  await inspectionsStore.removeItem(clientId);
}

/* Photo blobs stored separately so we don't bloat inspection objects */
export async function savePhotoBlob(localId, blob) {
  await photoStore.setItem(localId, blob);
}
export async function getPhotoBlob(localId) {
  return await photoStore.getItem(localId);
}
export async function removePhotoBlob(localId) {
  await photoStore.removeItem(localId);
}
